// @flow
import type { ScaleProps } from './component'
import { motionScale, Scale as scale } from './component'
import { connect } from 'react-redux'

function mapStateToProps ({ extents, overallExtents }): ScaleProps {
  return {
    minimum: extents[0] !== undefined ? extents[0] : 0,
    maximum: extents[1] !== undefined ? extents[1] : 15,
    overallMinimum: overallExtents[0],
    overallMaximum: overallExtents[1]
  }
}

export const MotionScale = connect(mapStateToProps, null)(motionScale)

export const Scale = connect(mapStateToProps, null)(scale)

export default MotionScale



// WEBPACK FOOTER //
// ./src/components/scale/container.js